<script lang="ts">
  let { color = 'currentColor' } = $props()
</script>

<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M21 12V20C21 20.5523 20.5523 21 20 21H8C7.44772 21 7 20.5523 7 20L7 4C7 3.44772 7.44772 3 8 3H14"
    stroke={color}
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M7 4.5H3.5C2.94772 4.5 2.5 4.94772 2.5 5.5V9.5C2.5 10.0523 2.94772 10.5 3.5 10.5H7"
    stroke={color}
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M6.5 14H5.5C4.94772 14 4.5 14.4477 4.5 15V18.5C4.5 19.0523 4.94772 19.5 5.5 19.5H7"
    stroke={color}
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M14 3.16107V20.5M7 12H21"
    stroke={color}
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M17 6H23"
    stroke={color}
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M20 3V9"
    stroke={color}
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
